import React from 'react';
import { Card, Col, Container, Image, Row } from 'react-bootstrap';
import Menu from '../Menu/Menu';
import sport from '../../images/sports.png';
import './SportsBike'
import Dashboard from '../DashBoard/Dashboard';
import Footer from '../Footer/Footer';

const SportsBike = () => {
    return (
        <div>
            <Menu></Menu>
            <Container>
            <Card className='about-me m-auto mt-5' style={{ width: '90%' }}>
            <Card.Body>
            <p className='section-title'>SPORTS BIKE</p>
            <Row data-aos="zoom-in" data-aos-easing="ease-out-cubic"
        data-aos-duration="1000" className='project-div mt-4'>
                  <Col xs={12} sm={12} md={6}>
                  <Image src={sport} rounded fluid />
                      
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                      <p style={{fontFamily:'Montserrat',color:'rgb(90, 89, 89)',fontWeight:'700'}}>Home page</p>
                      <p style={{fontSize:'14px',color:'rgb(90, 89, 89)'}}>
                          <span style={{fontWeight:'700'}}>Technologies Used:</span>
                       React, React Bootstrap, React Hook
                    Form, Material UI, Firebase, Node (Express JS For CRUD
                    operation), React Hook form, MongoDB.
                      </p>
                      <p style={{fontSize:'14px'}}>
                      This is a fully responsive website. Here a user can buy a bike.
                      </p>
                      
                      <p style={{fontSize:'14px'}}>Here is a Dashboard for both user and admin. To access more feature of this website a user needs to  login with email and password. If someone is new user he needs to register him to purchase something or gets access to dashboard.  </p>
                 
                      <div className='site-links' style={{fontSize:'14px',marginBottom:'20px'}}>
                         <a rel='noreferrer' target="_blank" href="https://github.com/somiyaPrity/Sports-Bike">Client Site Code</a>
                         <a rel='noreferrer' target="_blank" href="https://github.com/somiyaPrity/Sports-bike-server-site">Server Site Code</a>
                         <a rel='noreferrer' target="_blank" href="https://sports-bike-6aaee.web.app/">Live Site</a>
                      </div>
                  </Col>
              </Row>
              <Dashboard></Dashboard>
              </Card.Body>
            
              </Card>
              
            </Container>
            <Footer></Footer>
        </div>
    );
};

export default SportsBike;